import React from "react";
import MattImage from "../../assets/MattPrimeau.png";
import YangImage from "../../assets/YangWang.png";
import ScottImage from "../../assets/ScottWoods.png";

const TheTeam = () => {
    return (
        <div className="min-h-screen bg-darkblue text-lightgray px-6 py-16">
            <div className="max-w-4xl mx-auto text-center">
                <h1 className="text-4xl text-orange mb-12">
                    Meet the Team
                </h1>

                <div className="flex flex-col sm:flex-row justify-center items-center gap-12">
                    <div className="flex flex-col items-center">
                        <img
                            src={MattImage}
                            alt="Matt Primeau"
                            className="w-40 h-auto rounded-full"
                        />
                        <h2 className="text-xl font-semibold mt-4">Matt Primeau</h2>
                        <p className="text-md text-gray-300">Co-Founder &amp; CEO</p>
                    </div>

                    <div className="flex flex-col items-center">
                        <img
                            src={YangImage}
                            alt="Yang Wang"
                            className="w-40 h-auto rounded-full"
                        />
                        <h2 className="text-xl font-semibold mt-4">Yang Wang</h2>
                        <p className="text-md text-gray-300">Co-Founder &amp; CFO</p>
                    </div>

                    <div className="flex flex-col items-center">
                        <img
                            src={ScottImage}
                            alt="Scott Woods"
                            className="w-40 h-auto rounded-full"
                        />
                        <h2 className="text-xl font-semibold mt-4">Scott Woods</h2>
                        <p className="text-md text-gray-300">Co-Founder &amp; CTO</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TheTeam;
